/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountTemplate
 */
export interface AccountTemplate {
    /**
     * The UTC DateTime when the item was created
     * @type {string}
     * @memberof AccountTemplate
     */
    createdDateTime?: string;
    /**
     * This is the same as the email body. If the sender enters an email blurb, it is included in the email body for all template recipients
     * @type {string}
     * @memberof AccountTemplate
     */
    emailBlurb?: string;
    /**
     * The subject line of the email message that is sent to all recipients
     * @type {string}
     * @memberof AccountTemplate
     */
    emailSubject?: string;
    /**
     * The GUID of the template's folder
     * @type {string}
     * @memberof AccountTemplate
     */
    folderId?: string;
    /**
     * The name of the template's folder
     * @type {string}
     * @memberof AccountTemplate
     */
    folderName?: string;
    /**
     * The date and time when the sign request status was initially set (e.g., when created or sent)
     * @type {string}
     * @memberof AccountTemplate
     */
    pageCount?: string;
    /**
     * The ID of the template
     * @type {string}
     * @memberof AccountTemplate
     */
    templateId?: string;
    /**
     * The template's name
     * @type {string}
     * @memberof AccountTemplate
     */
    templateName?: string;
    /**
     *  The URI for retrieving the templates
     * @type {string}
     * @memberof AccountTemplate
     */
    templatesUri?: string;
    /**
     * A URI containing the user ID
     * @type {string}
     * @memberof AccountTemplate
     */
    uri?: string;
}

/**
 * Check if a given object implements the AccountTemplate interface.
 */
export function instanceOfAccountTemplate(value: object): boolean {
    return true;
}

export function AccountTemplateFromJSON(json: any): AccountTemplate {
    return AccountTemplateFromJSONTyped(json, false);
}

export function AccountTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'createdDateTime': json['createdDateTime'] == null ? undefined : json['createdDateTime'],
        'emailBlurb': json['emailBlurb'] == null ? undefined : json['emailBlurb'],
        'emailSubject': json['emailSubject'] == null ? undefined : json['emailSubject'],
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
        'folderName': json['folderName'] == null ? undefined : json['folderName'],
        'pageCount': json['pageCount'] == null ? undefined : json['pageCount'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'templateName': json['templateName'] == null ? undefined : json['templateName'],
        'templatesUri': json['templatesUri'] == null ? undefined : json['templatesUri'],
        'uri': json['uri'] == null ? undefined : json['uri'],
    };
}

export function AccountTemplateToJSON(value?: AccountTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdDateTime': value['createdDateTime'],
        'emailBlurb': value['emailBlurb'],
        'emailSubject': value['emailSubject'],
        'folderId': value['folderId'],
        'folderName': value['folderName'],
        'pageCount': value['pageCount'],
        'templateId': value['templateId'],
        'templateName': value['templateName'],
        'templatesUri': value['templatesUri'],
        'uri': value['uri'],
    };
}

